(function() {
  const originalSelectCallback = window.selectCallbackTheme;

  window.selectCallbackTheme = function(productEl, product, variant, state) {
    originalSelectCallback(productEl, product, variant, state);

    const productTags = product && product.tags;
    const isSpecialOrder = Array.isArray(productTags)
      ? productTags.includes('SpecialOrder:Y')
      : typeof productTags === 'string' && productTags.indexOf('SpecialOrder:Y') !== -1;

    if (variant && !variant.available && isSpecialOrder) {
      const $product = $(productEl);
      const $notifyForm = $('.product__notify-form', $product);
      const $notifyFormInputs = $('.notify_form__inputs');
      const buttonLabel = window.PXUTheme.translation.soldOut;

      $('[data-add-to-cart-trigger]', $product)
        .removeClass('disabled')
        .removeAttr('disabled')
        .attr('data-options-unselected', null)
        .find('span:not(.icon)')
        .text(buttonLabel);

      $('.sold_out', $product).text('');
      $('.shopify-payment-button', $product).show();
      $('.purchase-details__quantity', $product).show();
      $notifyForm.hide();
      $notifyFormInputs.empty();
    }
  };
})();